<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="form-box">
        <!-- <div style="color: #000">{{ dataForm }}</div> -->
        <div class="title">发布产品</div>
        <el-form ref="form" :model="dataForm" size="large" label-width="200px" :rules="rules">
          <el-form-item label="产品名称:" prop="prodtName">
            <el-input v-model="dataForm.prodtName" style="width: 600px" :maxlength="30" />
          </el-form-item>
          <el-form-item label="产品类型:" prop="prodtType">
            <el-radio-group v-model="dataForm.prodtType">
              <el-radio v-for="item in prodtTypeList" :key="item.cd" :label="item.cd">
                {{ item.nm }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="产品介绍:" prop="prodtDes">
            <el-input v-model="dataForm.prodtDes" :maxlength="500" type="textarea" show-word-limit :rows="7" style="width: 600px" />
          </el-form-item>
          <el-form-item label="产品图片:" prop="prodtPictureUrl">
            <Upload v-model="dataForm.prodtPictureUrl" :limit="5" :limit-size="1">
              <div slot="tip">
                <div>1. 支持扩展名jpg、png，图片大小不超过 1 MB</div>
                <div>2. 支持最多上传5张图片</div>
              </div>
            </Upload>
          </el-form-item>
          <el-form-item label="产品网址:" prop="prodtUrl">
            <el-input v-model="dataForm.prodtUrl" style="width: 600px" :maxlength="80" />
          </el-form-item>
          <el-form-item label="联系电话:" prop="contractNum">
            <el-input v-model="dataForm.contractNum" style="width: 600px" :maxlength="20" />
          </el-form-item>
          <el-form-item label="联系手机:" prop="contractPhone">
            <el-input v-model="dataForm.contractPhone" :maxlength="11" style="width: 600px" />
          </el-form-item>
          <el-form-item label="电子邮箱:" prop="email">
            <el-input v-model="dataForm.email" :maxlength="50" style="width: 600px" />
          </el-form-item>
          <el-form-item label="企业经营地:" prop="companyLocal">
            <el-select v-model="dataForm.companyLocal">
              <el-option v-for="item in cityItems" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <div class="tips">注：以上所填写的信息有企业自行提供，内容的真实性、准确性和合法性由发布企业负责。</div>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="sub-btn" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Upload from '@/components/Upload'
export default {
  components: { Breadcrumb, Upload },
  data() {
    return {
      dataForm: {},
      prodtTypeList: [],
      rules: {
        prodtName: [{ required: true, message: '请填写产品名称', trigger: 'blur' }],
        prodtType: [{ required: true, message: '请选择产品类型', trigger: 'change' }],
        prodtDes: [{ required: true, message: '请填写产品介绍', trigger: 'blur' }],
        prodtPictureUrl: [{ required: true, message: '请上传产品图片', trigger: 'change' }],
      },
      cityItems: ['鄞州区', '海曙区', '北仑区', '镇海区', '江北区', '奉化区', '慈溪市', '余姚市', '宁海县', '象山县'],
      breadcrumb: [
        {
          path: '/user',
          name: '个人中心',
          meta: {
            title: '个人中心',
          },
        },
        {
          path: '/user/myProduct',
          name: '我的产品',
          meta: {
            title: '我的产品',
          },
        },
        {
          path: '/user/product/add',
          name: '发布产品',
          meta: {
            title: '发布产品',
          },
        },
      ],
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.queryDetail(this.$route.query.id)
    }
    this.getEnum('ZzmhProductEn$ProdtType', 'prodtTypeList')
  },
  methods: {
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = res.data.list
      })
    },
    queryDetail(id) {
      this.$http({ method: 'get', url: '/zzmh/in/product/info/' + id }).then((res) => {
        this.dataForm = res.data
      })
    },
    checkForm() {
      let pass
      this.$refs.form.validate((val) => {
        pass = val
      })
      return pass
    },
    submit() {
      if (!this.checkForm()) return
      let params = {
        ...this.dataForm,
      }
      let api = params.id ? '/zzmh/in/product/upd' : '/zzmh/in/product/add'
      this.$http({ method: 'post', url: api, data: params }).then((res) => {
        this.$message.success('操作成功')
        this.$router.back()
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .wrap {
    display: flex;
    flex-direction: column;
    .tips {
      color: #666;
      font-size: 14px;
    }
    .form-box {
      flex: 1;
      background: #fff;
      padding: 30px;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        color: rgba(51, 51, 51, 0.85);
        text-align: center;
        line-height: 24px;
        font-weight: 600;
        margin-bottom: 40px;
      }
    }
    .sub-btn {
      display: block;
      width: 176px;
      margin: 40px auto;
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
